<template>
  <paper
    title="Job Template"
    body-class="mt-0"
    paper-class="mh-100 overflow-auto"
  >
    <div class="px-2 pb-2">
      <b-row>
        <b-col>
          <job-sidebar-group
            :active-tab="activeTab"
            :tabs="[generalTab]"
            :max-tabs="1"
            :disable-add="disableAdd"
            @selected="selected"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <job-sidebar-group
            title="Inputs"
            :active-tab="activeTab"
            :tabs="inputTabs"
            :max-tabs="1"
            empty-message="Start by adding inputs. These are the files that need to be transcoded."
            :disable-add="disableAdd"
            @selected="selected"
            @add="add('input')"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <job-sidebar-group
            title="Output Groups"
            :active-tab="activeTab"
            :tabs="outputTabs"
            empty-message="Add output groups and outputs to define the transcoding settings for your job outputs."
            no-border
            :active-child-index="activeChildIndex"
            :disable-add="disableAdd"
            @selected="selected"
            @add="() => add('output')"
            @childSelected="childSelected"
          />
        </b-col>
      </b-row>
    </div>
  </paper>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'
import JobSidebarGroup from './JobSidebarGroup.vue'

export default {
  name: 'JobSidebar',
  components: {
    Paper,
    JobSidebarGroup,
  },
  props: {
    generalTab: {
      type: Object,
      default: null,
    },
    inputTabs: {
      type: Array,
      default: null,
    },
    outputTabs: {
      type: Array,
      default: null,
    },
    activeTab: {
      type: Object,
      default: null,
    },
    isLiveJob: {
      type: Boolean,
      default: false,
    },
    activeChildIndex: {
      type: Number,
      default: null,
    },
    disableAdd: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    add(type) {
      this.$emit('addTab', type)
    },
    selected(tab) {
      this.$emit('selected', tab)
    },
    childSelected(obj) {
      this.$emit('childSelected', obj)
    },
  },
}
</script>

<style></style>
